import type { TextBuildingBlock } from 'types/textBuildingBlocks';
import { DropdownContainer, DropdownMessage, dropdownBoxStyle } from './dropdown/dropdown.styles';
import { useActiveItemScroll } from './dropdown/useActiveItemScroll';
import { DropdownItem } from './TextBuildingBlockDropdown.styles';

interface TextBuildingBlockDropdownProps {
  items: TextBuildingBlock[];
  activeIndex: number;
  message: string | null;
  maxHeight?: number;
  position?: { top: number; left: number };
  onSelect: (block: TextBuildingBlock) => void;
  onHover: (index: number) => void;
}

export const TextBuildingBlockDropdown = ({
  items,
  activeIndex,
  message,
  maxHeight,
  position,
  onSelect,
  onHover,
}: TextBuildingBlockDropdownProps) => {
  const activeItemRef = useActiveItemScroll<HTMLDivElement>(activeIndex);
  const style = dropdownBoxStyle(maxHeight, position);

  if (message) {
    return (
      <DropdownContainer role="listbox" style={style}>
        <DropdownMessage>{message}</DropdownMessage>
      </DropdownContainer>
    );
  }

  return (
    <DropdownContainer role="listbox" style={style}>
      {items.map((item, index) => (
        <DropdownItem
          key={item.abbreviation}
          role="option"
          aria-selected={index === activeIndex}
          $active={index === activeIndex}
          ref={index === activeIndex ? activeItemRef : undefined}
          // onMouseDown (not onClick) + preventDefault keeps the textarea focused through the click.
          onMouseDown={(event) => {
            event.preventDefault();
            onSelect(item);
          }}
          // onMouseMove, not onMouseEnter: scrolling fires mouseenter on rows under a still cursor.
          onMouseMove={() => onHover(index)}
        >
          {item.abbreviation}
        </DropdownItem>
      ))}
    </DropdownContainer>
  );
};
